<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/as-colour/products/*', { eager: true });

useHead({});

const products = [
	{
		title: "Classic Oversized Tee",
		src: imagesGlob["../../images/brands/as-colour/products/classic-oversized-tee.jpg"].default
	},
	{
		title: "Classic Long Sleeve Tee",
		src: imagesGlob["../../images/brands/as-colour/products/classic-long-sleeve-tee.jpg"].default
	},
	{
		title: "Relax Crew",
		src: imagesGlob["../../images/brands/as-colour/products/relax-crew.jpg"].default
	},
	{
		title: "Stencil Track Pants",
		src: imagesGlob["../../images/brands/as-colour/products/stencil-track-pants.jpg"].default
	},
	{
		title: "Relax Track Shorts",
		src: imagesGlob["../../images/brands/as-colour/products/relax-track-shorts.jpg"].default
	},
	{
		title: "Two Tone Carrier Tote",
		src: imagesGlob["../../images/brands/as-colour/products/two-tone-carrier-tote.jpg"].default
	},
	{
		title: "Frame Two-Tone Cap",
		src: imagesGlob["../../images/brands/as-colour/products/frame-twotone-cap.jpg"].default
	},
	{
		title: "Relaxed Hood",
		src: imagesGlob["../../images/brands/as-colour/products/relaxed-hood.jpg"].default
	},
	{
		title: "Stencil Half Zip Crew",
		src: imagesGlob["../../images/brands/as-colour/products/stencil-half-zip-crew.jpg"].default
	},
	{
		title: "Relax Zip Hood",
		src: imagesGlob["../../images/brands/as-colour/products/relax-zip-hood.jpg"].default
	},
	{
		title: "Cuff Beanie",
		src: imagesGlob["../../images/brands/as-colour/products/cuff-beanie.jpg"].default
	},
	{
		title: "Escape Travel Bag",
		src: imagesGlob["../../images/brands/as-colour/products/escape-travel-bag.jpg"].default
	},
];
</script>

<template lang="pug">
.page.page--brand.as-colour
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/as-colour/logo.webp')
				h1 Custom AS Colour
			.image
				img(src='@static/images/brands/as-colour/hero.webp' alt="Man standing in front of a serene lake and mountain backdrop, wearing a grey hoodie and matching sweatpants from AS Colour.")
	section.section.section--subhero
		.section__content
			.copy
				h3 PREMIUM BLANKS FOR BOLD DESIGNS
				p Since 2005, their mission has been clear: craft premium, purpose-driven blanks that empower self-expression. Every tee, hoodie, and hat is a blank canvas built with thoughtful construction, superior fabrics, and a clean, modern look. Born in New Zealand and now loved worldwide, AS Colour is the go-to choice for artists, designers, and brands that refuse to settle for less. Built to last. Made to inspire. Custom AS Colour by Swagger is a trusted name in branded apparel for creators everywhere.

	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="as-colour")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/as-colour/banner.png' alt="Composite image featuring stacked AS Colour t-shirts in a range of colors on the left, a grey AS Colour hat on a matching grey background in the center, and an overhead view of AS Colour tank tops in varied orientations on the right.")
			.section__content
				.copy
					h2 FIT. FABRIC. FINISH
					p AS Colour’s design philosophy is rooted in three essentials: <b>fit, fabric, and finish</b>. Every garment is tailored for modern wearability, using premium yarns that deliver long-term durability and comfort. Their commitment to impeccable finish means smoother surfaces, cleaner lines, and garments that print like a dream. It’s why creators come back again and again, because AS Colour isn’t just another blank. It’s the foundation of great design.
		
		section.section.section--foot
			.bg
			.section__content
				.pack
					.item
						img(src='@static/images/brands/as-colour/pack-1.webp' alt='Woman in a desert landscape at golden hour, wearing a white AS Colour t-shirt and cream AS Colour shorts.')
					.item
						img(src='@static/images/brands/as-colour/pack-2.webp' alt='Close-up of AS Colour t-shirt fabric in a soft powder blue color, showing texture and detail.')
					.item
						img(src='@static/images/brands/as-colour/pack-3.webp' alt='Close-up of AS Colour fabric showcasing a printed design, highlighting the texture of the material and the decoration method.')

</template>

<style></style>